import { api } from '@/lib/api';
import type {
  Publication,
  PublicationFilters,
  PublicationListResponse,
  PublicationPatch,
} from './types';

export async function listPublications(filters: PublicationFilters = {}): Promise<PublicationListResponse> {
  return api.get<PublicationListResponse>('/v4/publications', {
    ...filters,
    pageLength: 100,
  });
}

export async function getPublication(id: string): Promise<Publication> {
  return api.get<Publication>(`/v4/publications/${id}`);
}

export async function createPublication(data: PublicationPatch): Promise<Publication> {
  return api.post<Publication>('/v4/publications', data);
}

export async function updatePublication(id: string, data: PublicationPatch): Promise<Publication> {
  return api.patch<Publication>(`/v4/publications/${id}`, data);
}

export async function deletePublication(id: string): Promise<void> {
  return api.delete<void>(`/v4/publications/${id}`);
}
